import { api } from "../ModuloGerenciador/UrlPadrao"

export const getGeralCheck = async (token) => {
  return api.get("geralCheck/",
    {
      headers: {
        'Authorization': token
      }
    })
}